<div class="parallax">
  <div class="parallax__layer parallax__layer--back">
    <div class="title">This is the background</div>
  </div>
  <div class="parallax__layer parallax__layer--base">
    <div class="title">This is the foreground</div>
  </div>
</div>